import loadable from "@loadable/component";
import { inject } from "mobx-react";
import type { Store } from "@inferno/renderer-shared-core";

import { AgentOSType } from "@inferno/renderer-shared-core";
import { Remote } from "../../../../core/components/remote/Remote.component";
import { isPWSSessionBackend, PWSSessionBackend, PwsMediaEpisode } from "@inferno/renderer-shared-core";
import { CoastMediaPlayerSkeleton } from "./CoastMediaPlayerSkeleton.component";
import { coastMediaService } from "../../../../core/services/Pws";

const CoastMediaReactPlayer = loadable(() => import("./CoastMediaReactPlayer.component"), { ssr: false });

interface CoastMediaPlayerLoaderProps {
  playNextEpisode: () => void;
  session: PWSSessionBackend;
  osType: AgentOSType | null;
  episode: PwsMediaEpisode;
  playerApiKey: string;
  store?: Store;
}

export const CoastMediaPlayerLoader = inject("store")(({ store, episode, ...props }: CoastMediaPlayerLoaderProps) => {
  const session = store?.session.currentSession;
  if (!store || !isPWSSessionBackend(session)) {
    return null;
  }
  return (
    <Remote
      // isAudio is already set on live videos
      loader={() =>
        typeof episode.isAudio === "boolean"
          ? Promise.resolve(episode.isAudio)
          : coastMediaService
              .getIsAudioEpisode(session.state.accessToken, episode.id, episode.onAir)
              .then(r => r.isAudio)
      }
      cacheKey={`coast-is-audio-episode-${episode.id}`}
      fallback={<CoastMediaPlayerSkeleton />}
      showLoading={true}
    >
      {({ data: isAudio }) => <CoastMediaReactPlayer isAudio={!!isAudio} episode={episode} {...props} />}
    </Remote>
  );
});
